import type { RawUser } from '../types';
import { ProfileType } from '../types';

import type { RawClient } from './types';

export function isRawClient(rawUser: RawUser): rawUser is RawClient {
  return rawUser.profiles[0].profile_type === ProfileType.Client;
}
